/**
 * Prescription Status Enum
 *
 * Values synced with backend PrescriptionStatusEnum.
 * @see backend/src/backend/db/constants/prescrition_status.py
 *
 * Backend values:
 * - ACTIVE = 1
 * - CANCELED = 2
 * - DISPENSED = 3
 * - NOT_DISPENSED = 4
 */
import { intl } from "dmsbasereact";

export const PRESCRIPTION_STATUS = {
    ACTIVE: 1,
    CANCELED: 2,
    DISPENSED: 3,
    NOT_DISPENSED: 4,
};

export const PrescriptionStatus = {
    getText: (code) => {
        switch (code) {
            case PRESCRIPTION_STATUS.ACTIVE:
                return intl.get("Active").d("Active");
            case PRESCRIPTION_STATUS.CANCELED:
                return intl.get("Canceled").d("Canceled");
            case PRESCRIPTION_STATUS.DISPENSED:
                return intl.get("Dispensed").d("Dispensed");
            case PRESCRIPTION_STATUS.NOT_DISPENSED:
                return intl.get("NotDispensed").d("Not Dispensed");
            default:
                return intl.get("Unknown").d("Unknown");
        }
    },
    getColor: (code) => {
        switch (code) {
            case PRESCRIPTION_STATUS.ACTIVE:
                return "success";
            case PRESCRIPTION_STATUS.CANCELED:
                return "error";
            case PRESCRIPTION_STATUS.DISPENSED:
                return "info";
            case PRESCRIPTION_STATUS.NOT_DISPENSED:
                return "warning";
            default:
                return "default";
        }
    }
};

/**
 * Get prescription status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getPrescriptionStatusOptions = () => [
    { value: PRESCRIPTION_STATUS.ACTIVE, label: PrescriptionStatus.getText(PRESCRIPTION_STATUS.ACTIVE) },
    { value: PRESCRIPTION_STATUS.CANCELED, label: PrescriptionStatus.getText(PRESCRIPTION_STATUS.CANCELED) },
    { value: PRESCRIPTION_STATUS.DISPENSED, label: PrescriptionStatus.getText(PRESCRIPTION_STATUS.DISPENSED) },
    { value: PRESCRIPTION_STATUS.NOT_DISPENSED, label: PrescriptionStatus.getText(PRESCRIPTION_STATUS.NOT_DISPENSED) }
];
